/**
* @summary - Component that Provides PPM SCHEDULE functionality
* @autor vengateshwaran k
* @since 2024-06-21
*/
import { Box, Button, Grid, Typography } from "@mui/material";
import { addMonths, addWeeks, endOfYear, format, getWeek, isAfter, isBefore, parseISO } from 'date-fns';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import commonMasterRepository from "../../api/repositories/commonMasterRepository";
import PpmPlannerRepository from '../../api/repositories/ppmPlannerRepository';
import { DefaultCard } from "../../assets/styled-components/card";
import { setHeaderName, setSelectedIndex } from "../../redux/actions/userActions";
import commonMessages from '../../utility/constant';
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import CustomDialog from '../commoncomponents/CustomDialog';
import CustomSelectInput from '../commoncomponents/CustomSelectInput';
import CustomTextField from "../commoncomponents/CustomTextField";
import RefreshExportButtons from '../commoncomponents/RefreshExportButtons';
import AddPPM from './addPPM';
import PageLoader from "../commoncomponents/PageLoader";
import PremitiveMaintenanceRepository from "../../api/repositories/premitiveMaintenanceRepository";
import { current } from "@reduxjs/toolkit";
import { useAccess } from "../../AccessContext";
import utilities from "../../utility/utilities";
const PpmSchedule = ({ handleYear, handleWorkGroup, handleServiceType, facilityId, companyId, handleAllRows, selectedWorkgroup, selectedYear, selectedServiceType, allGridRows, selectedApprovedBy, selectedProposedBy, handleApprovedBy, handleProposedBy }) => {

  const accessData = useAccess();
  const access = utilities.getScreenPermissions(accessData, "ENGT002");
  
  const dispatch = useDispatch();
  const [gridApi, setGridApi] = useState({});
  const [approvedBy, setApprovedBy] = useState('');
  const [proposedBy, setProposedBy] = useState('');
  const [serviceType, setServiceType] = useState(null);
  const [serviceTypeOptions, setServiceTypeOptions] = useState([]);
  const [workGroup, setWorkGroup] = useState(null);
  const [workGroupOptions, setWorkGroupOptions] = useState([]);
  const [year, setYear] = useState(null);
  const [yearOptions, setYearOptions] = useState([]);
  const [showAddRowDialog, setShowAddRowDialog] = useState(false);
  const [selectedRows, setSelectedRows] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [allRows, setAllRows] = useState([]);
  const [selectedId, setSelectedId] = useState(null) //setSelectedId
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [confirmationDeleteDialogOpen, setConfirmationDeleteDialogOpen] = useState(false);
  const [assetAll, setAssetAll] = useState([]);
  const [taskCodeList, setTaskCodeList] = useState([]);


  const colDefs = [
    {
      headerName: "",
      headerClass: "header-centered",
      children: [

        {
          field: "assetno", headerName: "Asset No",

        },
        {
          field: "assetdesc", headerName: "Asset Description",

        },
        {
          field: "departmentdesc", headerName: "Department Description",
        },
        {
          field: "taskcode", headerName: "Task Code",

        },]
    },
    {
      headerName: "Schedule & Target Date Details",
      headerClass: "header-centered",
      children: [
        {
          field: "scheduledfrequency", headerName: "Scheduled Frequency",
          cellStyle: { textAlign: "right" }

        },
        {
          field: "period", headerName: "Period",

        },
        {
          field: "targetdate", headerName: "Target Date",

        },

        // },
        // {
        //   headerName: "",
        //   children: [

        {
          field: "nextppmdate", headerName: "Next PPM Date",

        },
        {
          field: "respondtype", headerName: "Respond Type",

        },
        { field: "vendorname", headerName: "Vendor" },
        { field: "staffname", headerName: "Assignee" },
      ]
    },
  ];
  const hasMounted = useRef(false);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [addPPMLoading, setAddPPMLoading] = useState(false);
  const fetchOptions = async () => {
    try {
      setErrors({});
      const workgroupdetails = await commonMasterRepository.getWorkGroupDetails(facilityId);
      const allOption = { label: "All", value: "All", id: null };
     
      // Merge "All" option with the fetched details
      setWorkGroupOptions([allOption, ...(workgroupdetails || [])]);

     

      if (workgroupdetails?.length > 0) {
        // Set the selected workgroup to either the selectedWorkgroup or the one labeled 'W1'
        setWorkGroup(selectedWorkgroup || workgroupdetails.find((item) => item?.label === 'W1'));

       
      }

      const responseMasters = await commonMasterRepository.getMasters(facilityId, companyId);
      setServiceTypeOptions(responseMasters || []);
      setServiceType(selectedServiceType || responseMasters?.find((item) => item?.label === 'FEMS'))

      const maintanenceyear = await commonMasterRepository.getMaintanenceYear(facilityId);
      // setYearOptions(maintanenceyear?.filter((item) => item?.label === new Date().getFullYear()));
      setYearOptions(maintanenceyear || []);
      if (selectedYear != undefined) {
        setYear(selectedYear);
      }
      else {
        setYear(maintanenceyear?.find((item) => Number(item?.label) === new Date().getFullYear()) || maintanenceyear[0]);
      }
      setApprovedBy(selectedApprovedBy || '');
      setProposedBy(selectedProposedBy || '');
      setAllRows(allGridRows || []);
    }
    catch (e) {
      console.log(e)
    }

  }

  useEffect(() => {
    if (!hasMounted.current) {
      fetchOptions();
      hasMounted.current = true;
    }
  }, []);
  const listLength = useMemo(() => {
    if (allRows?.length) {
      return allRows?.length
    }
    return 0;
  }, [allRows])
  const fieldsChange = useMemo(() => {
    handleYear(year);
    handleWorkGroup(workGroup);
    handleProposedBy(proposedBy);
    handleApprovedBy(approvedBy);
    handleServiceType(serviceType);
    handleAllRows(allRows);
  }, [approvedBy, proposedBy, serviceType, workGroup, year, allRows])

  const fetchPpmDetails = async (yearID, serviceType, workGroupID) => {
    try {

      setLoading(true);
      const vendorOption = await PpmPlannerRepository.getVendorList(
        companyId
      );
      const employeeList = await PremitiveMaintenanceRepository.getStaffDetails(facilityId);
      let ppmschedule;
      if (serviceType?.label === 'FEMS') {
        const taskCodeLists = await PpmPlannerRepository.getTaskCodeDetails(
          facilityId,
          workGroup?.id
        );

        ppmschedule = await PpmPlannerRepository.getPpmDetails(facilityId, workGroupID, yearID);

        if (ppmschedule) {
          const setAllRow = ppmschedule?.data?.map((item) => {
            if (item?.approvedbyhss && item?.approvedbymoh) {
              setProposedBy(item?.approvedbyhss);
              setApprovedBy(item?.approvedbymoh);
            }

            // Calculate next PPM date based on interval type
            let nextPpmDate;
            const startFromDate = parseISO(item?.startfromdate);
            const currentDate = new Date();

            if (item?.femppmintervaltypeId === 1) { // Weeks
              nextPpmDate = addWeeks(startFromDate, item?.intervalunit);
              while (isBefore(nextPpmDate, currentDate)) {
                nextPpmDate = addWeeks(nextPpmDate, item?.intervalunit);
              }
            } else if (item?.femppmintervaltypeId === 2) { // Months
              nextPpmDate = addMonths(startFromDate, item?.intervalunit);
              while (isBefore(nextPpmDate, currentDate)) {
                nextPpmDate = addMonths(nextPpmDate, item?.intervalunit);
              }
            }
            const nextPpmDateFormatted = format(nextPpmDate, 'dd/MM/yyyy');

            let datas = {
              ...item,
              scheduledfrequency: item?.intervalunit,
              targetdate: format(parseISO(item?.startfromdate), 'dd/MM/yyyy'),
              nextppmdate: nextPpmDateFormatted,
              respondtype: item?.femassetppmstatusId === 1 ? "Outsource" : "Inhouse",
              period: item?.femppmintervaltypeId === 1 ? "Weeks" : "Months",
              assetno: item?.assetno || "",
              // taskcode: taskCodeLists?.find((items) => items?.id == item?.femtaskdetailsId)?.taskcode,
              taskcode: item?.taskcode || "",
              assetdesc: item?.assetdesc || "",
            };

            if ('vendorid' in item) {
              datas["vendorname"] = vendorOption.find((vendor) => vendor?.id === item?.vendorid)?.value
            }
            if ('staffid' in item) {
              datas["staffname"] = employeeList.find((emp) => emp?.id === item?.staffid)?.value
            }

            return datas;
          });
          setAllRows(setAllRow);
        }
      } else {
        const taskCodeLists = await PpmPlannerRepository.getTaskCodeDetails(
          facilityId,
          workGroup?.id
        );
        ppmschedule = await PpmPlannerRepository.getBemsPpmDetails(facilityId, workGroupID, yearID);
        if (ppmschedule) {
          const setAllRow = ppmschedule?.data?.map((item) => {
            if (item?.approvedbyhss && item?.approvedbymoh) {
              setProposedBy(item?.approvedbyhss);
              setApprovedBy(item?.approvedbymoh);
            }
            // Calculate next PPM date based on interval type
            let nextPpmDate;
            const startFromDate = parseISO(item?.startfromdate);
            const currentDate = new Date();

            if (item?.bemppmintervaltypeId === 1) { // Weeks
              nextPpmDate = addWeeks(startFromDate, item?.intervalunit);
              while (isBefore(nextPpmDate, currentDate)) {
                nextPpmDate = addWeeks(nextPpmDate, item?.intervalunit);
              }
            } else if (item?.bemppmintervaltypeId === 2) { // Months
              nextPpmDate = addMonths(startFromDate, item?.intervalunit);
              while (isBefore(nextPpmDate, currentDate)) {
                nextPpmDate = addMonths(nextPpmDate, item?.intervalunit);
              }
            }
            const nextPpmDateFormatted = format(nextPpmDate, 'dd/MM/yyyy');
            let datas = {
              ...item,
              scheduledfrequency: item?.intervalunit,
              targetdate: format(parseISO(item?.startfromdate), 'dd/MM/yyyy'),
              nextppmdate: nextPpmDateFormatted,
              respondtype: item?.bemassetppmstatusId === 1 ? "Outsource" : "Inhouse",
              period: item?.bemppmintervaltypeId === 1 ? "Weeks" : "Months",
              assetno: item?.assetno,
              taskcode: item?.taskcode || "",
              assetdesc: item?.assetdesc,
            }
            if ('vendorid' in item) {
              datas["vendorname"] = vendorOption.find((vendor) => vendor?.id === item?.vendorid)?.value
            }
            if ('staffid' in item) {
              datas["staffname"] = employeeList.find((emp) => emp?.id === item?.staffid)?.value
            }
            return datas;
          });
          setAllRows(setAllRow);
        }
      }


    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const serviceTypeChange = useMemo(() => {
    const fetchOptions = async () => {
      try {
        let workgroupdetails = [];
        let allOption = { label: "All", value: "00000000-0000-0000-0000-000000000000", id: "00000000-0000-0000-0000-000000000000" };

        if (serviceType?.label === "BEMS") {
          workgroupdetails = await commonMasterRepository?.getBemsWorkGroupDetails(facilityId);
        } else if (serviceType?.label === "FEMS") {
          workgroupdetails = await commonMasterRepository?.getWorkGroupDetails(facilityId);
        }

        // Update dropdown options
        const options = [allOption, ...(workgroupdetails || [])];
        setWorkGroupOptions(options);


        // Default selection logic
        const defaultLabel = serviceType?.label === "BEMS" ? "W8" : "W1";
        const workGroupSelection =
          selectedWorkgroup.label === ""
            ? workgroupdetails?.find((item) => item?.label === defaultLabel)
            : workgroupdetails?.find((item) => item?.label === selectedWorkgroup?.label);

        setWorkGroup(
          workGroupSelection?.label === undefined
            ? workgroupdetails?.find((item) => item?.label === defaultLabel)
            : workGroupSelection
        );

        // Clear other states
        setAllRows([]);
        setApprovedBy("");
        setProposedBy("");
      } catch (e) {
        console.log("Error in fetching work group options:", e);
      }
    };

    fetchOptions();
  }, [serviceType]);

  const ref = useMemo(() => {
    if (showAddRowDialog === false && year?.id && serviceType?.id && workGroup?.id) {
      fetchPpmDetails(year?.id, serviceType, workGroup?.id);
    }
  }, [showAddRowDialog])



  const validateFieldSelectFields = (name, fieldName) => {
    if (name === '' || name === undefined || name === null) {
      return `Please Select ${fieldName}`;
    }
    return '';
  };
  
  const handleGetResults = async () => {
    try {
      setPageLoading(true);
      const vendorOption = await PpmPlannerRepository.getVendorList(
        companyId
      );
      const employeeList = await PremitiveMaintenanceRepository.getStaffDetails(facilityId);
      const serviceTypeError = validateFieldSelectFields(serviceType, 'Service Type');
      const workGroupError = validateFieldSelectFields(workGroup, 'Work Group');
      const yearError = validateFieldSelectFields(year, 'Year');
      let ppmSchedule = null;
      if (serviceTypeError === '' && workGroupError === '' && yearError === '') {
        if (serviceType?.label === 'FEMS') {
          const taskCodeLists = await PpmPlannerRepository.getTaskCodeDetails(
            facilityId,
            workGroup?.id
          );
          ppmSchedule = await PpmPlannerRepository.getPpmDetails(facilityId, workGroup?.id, year?.id);
        
          const setAllRowss = ppmSchedule?.data?.map((item) => {
            if (item?.approvedbyhss && item?.approvedbymoh) {
              setProposedBy(item?.approvedbyhss);
              setApprovedBy(item?.approvedbymoh);
              setErrors({
                approvedBy: '',
                proposedBy: '',
              });
            } else {
              setProposedBy('');
              setApprovedBy('');
            }
            // Calculate next PPM date based on interval type
            let nextPpmDate;
            const startFromDate = parseISO(item?.startfromdate);
            const currentDate = new Date();

            if (item?.femppmintervaltypeId === 1) { // Weeks
              nextPpmDate = addWeeks(startFromDate, item?.intervalunit);
              while (isBefore(nextPpmDate, currentDate)) {
                nextPpmDate = addWeeks(nextPpmDate, item?.intervalunit);
              }
            } else if (item?.femppmintervaltypeId === 2) { // Months
              nextPpmDate = addMonths(startFromDate, item?.intervalunit);
              while (isBefore(nextPpmDate, currentDate)) {
                nextPpmDate = addMonths(nextPpmDate, item?.intervalunit);
              }
            }

            const nextPpmDateFormatted = format(nextPpmDate, 'dd/MM/yyyy');
            let datas = {
              ...item,
              scheduledfrequency: item?.intervalunit,
              targetdate: format(parseISO(item?.startfromdate), 'dd/MM/yyyy'),
              nextppmdate: nextPpmDateFormatted,
              respondtype: item?.femassetppmstatusId === 1 ? "Outsource" : "Inhouse",
              period: item?.femppmintervaltypeId === 1 ? "Weeks" : "Months",
              assetno: item?.assetno || "",
              taskcode: item?.taskcode || "",
              assetdesc: item?.assetdesc || "",
            }
            if ('vendorid' in item) {
              datas["vendorname"] = vendorOption.find((vendor) => vendor?.id === item?.vendorid)?.value
            }
            if ('staffid' in item) {
              datas["staffname"] = employeeList.find((emp) => emp?.id === item?.staffid)?.value
            }
            return datas
          })
          setAllRows(setAllRowss);
        } else {
          const taskCodeLists = await PpmPlannerRepository.getTaskCodeDetails(
            facilityId,
            workGroup?.id
          );
          ppmSchedule = await PpmPlannerRepository.getBemsPpmDetails(facilityId, workGroup?.id, year?.id);
          const setAllRowss = ppmSchedule?.data?.map((item) => {
            if (item?.approvedbyhss && item?.approvedbymoh) {
              setProposedBy(item?.approvedbyhss);
              setApprovedBy(item?.approvedbymoh);
              setErrors({
                approvedBy: '',
                proposedBy: '',
              });
            } else {
              setProposedBy('');
              setApprovedBy('');
            }
            // Calculate next PPM date based on interval type
            let nextPpmDate;
            const startFromDate = parseISO(item?.startfromdate);
            const currentDate = new Date();

            if (item?.bemppmintervaltypeId === 1) { // Weeks
              nextPpmDate = addWeeks(startFromDate, item?.intervalunit);
              while (isBefore(nextPpmDate, currentDate)) {
                nextPpmDate = addWeeks(nextPpmDate, item?.intervalunit);
              }
            } else if (item?.bemppmintervaltypeId === 2) { // Months
              nextPpmDate = addMonths(startFromDate, item?.intervalunit);
              while (isBefore(nextPpmDate, currentDate)) {
                nextPpmDate = addMonths(nextPpmDate, item?.intervalunit);
              }
            }

            const nextPpmDateFormatted = format(nextPpmDate, 'dd/MM/yyyy');
            let datas = {
              ...item,
              scheduledfrequency: item?.intervalunit,
              targetdate: format(parseISO(item?.startfromdate), 'dd/MM/yyyy'),
              nextppmdate: nextPpmDateFormatted,
              respondtype: item?.bemassetppmstatusId === 1 ? "Outsource" : "Inhouse",
              period: item?.bemppmintervaltypeId === 1 ? "Weeks" : "Months",
              assetno: item?.assetno || "",
              taskcode: item?.taskcode,
              assetdesc: item?.assetdesc || "",
            }
            if ('vendorid' in item) {
              datas["vendorname"] = vendorOption.find((vendor) => vendor?.id === item?.vendorid)?.value
            }
            if ('staffid' in item) {
              datas["staffname"] = employeeList.find((emp) => emp?.id === item?.staffid)?.value
            }
            return datas
          })
          setAllRows(setAllRowss);
        }
    
      } else {
        setErrors({
          serviceType: serviceTypeError,
          workGroup: workGroupError,
          year: yearError
        });
      }
    }
    catch (e) {
      console.log(e)
    } finally {
      setPageLoading(false);
    }
  }

  // const handleWoConfirm = async (row) => {
  //   const schduledWorkOredrresponse = serviceType?.label === 'FEMS' ? await PpmPlannerRepository.getWOScheduledList(row?.femassetregisterId) : await PpmPlannerRepository.getBemsWOScheduledList(row?.bemassetregisterId);
  //   // woListRef.current=schduledWorkOredrresponse;
  //   if (schduledWorkOredrresponse?.data?.length > 0) {
  //     const woCancelList = schduledWorkOredrresponse?.data?.map(async (item) => {
  //       let values = serviceType?.label === 'FEMS' ? { ...item, femworkorderstatusId: 6 } : { ...item, bemworkorderstatusId: 6 }
  //       const response = serviceType?.label === 'FEMS' ? await PpmPlannerRepository.cancelWorkOrders(item?.id, values) : await PpmPlannerRepository.cancelBemsWorkOrders(item?.id, values);
  //       return response;
  //     })
  //     const updateAllWoList = await Promise.all(woCancelList);
  //     const allSuccessful = updateAllWoList.every(item => item.status >= 200 && item.status <= 204);
  //     if (allSuccessful) {
  //       await handleDelete(row);
  //     } else if (updateAllWoList.status >= 400) {
     
  //     }
  //   } else {
  //     await handleDelete(row);
  //   }
  // }

  const handleDelete = async (row) => {
    // if (row?.id) {
    //   setPageLoading(true);
    //   const schedule = serviceType?.label === 'FEMS' ? await PpmPlannerRepository.getPpmShowSchedule(facilityId, workGroup?.id, year?.label) : await PpmPlannerRepository.getBemsPpmShowSchedule(facilityId, workGroup?.id, year?.label);
    //   if (serviceType?.label === 'FEMS') {
    //     setAssetAll(schedule?.data?.filter((item) => item?.femppmscheduledetails?.femassetregister?.assetno === row?.assetno));
    //   } else {
    //     setAssetAll(schedule?.data?.filter((item) => item?.bemppmscheduledetails?.bemassetregister?.assetno === row?.assetno));
    //   }
    
    // }
    // setPageLoading(false);
    setSelectedId(row?.id);
    setDeleteDialogOpen(true);
  }
  
  const confirmDelete = async () => {
    try {
      setPageLoading(true);
      let isDeleteTracks = false;
      setDeleteDialogOpen(false);
      const ppmScheduleDelete = serviceType?.label === 'FEMS' ? await PpmPlannerRepository.removePpmSchedule(selectedId) : await PpmPlannerRepository.removeBemsPpmSchedule(selectedId);
      if (ppmScheduleDelete?.status >= 200 && ppmScheduleDelete?.status <= 204) {
        setConfirmationDeleteDialogOpen(true);
        fetchPpmDetails(year?.id, serviceType, workGroup?.id);
        if (selectedId !== null || selectedId !== undefined) {                
            const updatePpmScheduleTracksDelete = serviceType?.label === "FEMS" ? 
            await PpmPlannerRepository.addPpmscheduleTracksDelete( selectedId ) :
                    await PpmPlannerRepository.addBemsPpmscheduleTracksDelete( selectedId );
              if(updatePpmScheduleTracksDelete?.status <= 204 ){
                isDeleteTracks = true
              }                              
          
          if (isDeleteTracks) {
            setSelectedId(null);
            setApprovedBy('');
            setProposedBy('');
            setPageLoading(false);
            setConfirmationDeleteDialogOpen(true);
            fetchPpmDetails(year?.id, serviceType, workGroup?.id);
          }
        } else {
          setSelectedId(null);
          setPageLoading(false);
          setConfirmationDeleteDialogOpen(true);
          fetchPpmDetails(year?.id, serviceType, workGroup?.id);
        }
      }
      setPageLoading(false);

    } catch (error) {
      console.log("Error fetching options:", error);
    }
  }

  const handleEdit = (id, type) => {
    setSelectedRows(id);
    setIsEdit(true);
    setShowAddRowDialog(true);
    setAddPPMLoading(true);
  };
  function AddRowButton(props) {
    const handleClick = () => {
      props.onClick();
    };

    return (

      <Button variant='contained' onClick={handleClick}>
        Add
      </Button>

    );
  }
  const validateField = (name, fieldName) => {
    const namePattern = /^[^\s][a-zA-Z\s]*$/;
    if (name === '' || name === undefined || name === null) {
      return `Please Enter ${fieldName}`;
    }

    if (!namePattern.test(name)) {
      return `Enter a valid name in the ${fieldName}.`;
    }

    return '';
  };


  const handleAddRow = () => {
    const approvedByError = validateField(approvedBy, 'Approved By');
    const proposedByError = validateField(proposedBy, 'Proposed By');

    if (approvedByError === '' && proposedByError === '' && serviceType != null && workGroup != null && year != null) {
      setShowAddRowDialog(true);
    } else {

      setErrors({
        approvedBy: approvedByError,
        proposedBy: proposedByError,
        serviceType: serviceType != null ? '' : "Please Select Service Type",
        workGroup: workGroup != null ? '' : "Please Select Work Group",
        year: year != null ? '' : "Please Select Year"
      });
    }
  };


  const handleCancelClick = () => {
    navigate('/dashboard');
    dispatch(setSelectedIndex('SET_INDEX_LABEL', ''));
    dispatch(setHeaderName('SET_HEADER_NAME', 'Dashboard'));
  }

  //   const generateDates = (
  //         start,
  //         frequency,
  //         ppmScheduleId,
  //         startFromDate,
  //         schFrequency
  //       ) => {
  //         let currentDate = new Date(start); // Start from the beginning of the given month
  //         const endDate = endOfYear(start);
  //         const datesArray = [];
  //         let weekNumber = 1;
  //         let schTrackYear = format(new Date(), "yyyy");
  //         let rows = serviceType?.label === 'FEMS' ? {
  //           isdeleted: false,
  //           week: "",
  //           trackyear: "",
  //           startfromdate: "",
  //           targetdate: "",
  //           femppmscheduledetails: {
  //             id: ppmScheduleId,
  //           },
  //         } : {
  //           isdeleted: false,
  //           week: "",
  //           trackyear: "",
  //           startfromdate: "",
  //           targetdate: "",
  //           bemppmscheduledetails: {
  //             id: ppmScheduleId,
  //           },
  //         };
  //         while (currentDate < endDate) {
  //           datesArray.push({
  //             ...rows,
  //             targetdate: format(new Date(currentDate), "yyyy-MM-dd'T'HH:mm:ss"),
  //             week: weekNumber,
  //             trackyear: schTrackYear,
  //             startfromdate: startFromDate,
  //           });
  //           currentDate =
  //             frequency === "Months"
  //               ? addMonths(currentDate, schFrequency === 0 ? 1 : schFrequency)
  //               : addWeeks(currentDate, schFrequency === 0 ? 1 : schFrequency);

  //           const date = new Date(currentDate);
  //           // Get the week number
  //           weekNumber = getWeek(date);
  //           console.log(currentDate,"currentDate");

  //           console.log(weekNumber,"weekNumber");

  //         }
  //         datesArray.splice(0, 1);
  //         console.log(datesArray,"datesArray");

  //         return datesArray;
  //       };


  //   const processRowsAndSendPayload = async (allRows, serviceType) => {
  //     for (const row of allRows) {
  //       console.log(row,"row");
  // const getTaskDestails = serviceType?.label === "FEMS" ? "femtaskdetailsId" : "bemtaskdetailsId";
  //       const currentYear = new Date().getFullYear();

  //       // if(!row?.schyear === currentYear){
  //         const generatedDates = generateDates(
  //           new Date(), // or any start date
  //           row.period,
  //           row.id,
  //           row.startfromdate, // or any start from date
  //           row.scheduledfrequency,
  //           row?.[`${getTaskDestails}`],
  //           serviceType,
  //       );
  // console.log(generatedDates,"generateddates");

  //       const setTracks = generatedDates.map(async (item) => {

  //         if(row?.schyear !== currentYear){
  //           if (serviceType?.label === 'FEMS') {
  //               return await PpmPlannerRepository.addPpmscheduleTracks(item);
  //           } else {
  //               return await PpmPlannerRepository.addBemsPpmscheduleTracks(item);
  //           }
  //         }
  //       });
  //       const updatePpmScheduleTracksInsert = await Promise.all(setTracks);
  //       console.log(updatePpmScheduleTracksInsert,"updatePpmScheduleTracksInsert"); // Handle the result as needed

  //       }
  // };

  const generateDates = (
    start,
    frequency,
    ppmScheduleId,
    startFromDate,
    schFrequency,
    taskdetails
  ) => {
    const currentYear = new Date().getFullYear(); // Get the current year (e.g., 2025)
    const startOfYear = new Date(currentYear, 0, 1); // January 1 of the current year
    const endOfYear = new Date(currentYear, 11, 31); // December 31 of the current year

    let currentDate = new Date(startFromDate); // Start from the given startFromDate
    const datesArray = [];
    const schTrackYear = String(currentYear); // Track year as a string
    const isFEMS = serviceType?.label === "FEMS";

    // Template for rows
    const rowsTemplate = {
      isdeleted: false,
      week: "",
      trackyear: "",
      startfromdate: "",
      targetdate: "",
      ...(isFEMS
        ? { femppmscheduledetails: { id: ppmScheduleId } }
        : { bemppmscheduledetails: { id: ppmScheduleId } }),
      ...(isFEMS
        ? { femtaskdetailsId: taskdetails }
        : { bemtaskdetailsId: taskdetails }),
    };

    // Align currentDate to the first valid date in the current year
    while (currentDate < startOfYear) {
      if (frequency === "Weeks") {
        currentDate = addWeeks(currentDate, schFrequency === 0 ? 1 : schFrequency);
      } else if (frequency === "Months") {
        currentDate = addMonths(currentDate, schFrequency === 0 ? 1 : schFrequency);
      }
    }

    // Generate dates for the current year
    while (currentDate <= endOfYear) {
      const weekNumber = getWeek(currentDate); // Dynamically calculate week number

      // Push the row with the calculated target date
      datesArray.push({
        ...rowsTemplate,
        targetdate: format(new Date(currentDate), "yyyy-MM-dd'T'HH:mm:ss"),
        week: weekNumber,
        trackyear: schTrackYear,
        startfromdate: startFromDate,
      });

      // Increment the date based on the given frequency
      if (frequency === "Weeks") {
        // Weekly increment
        currentDate = addWeeks(currentDate, schFrequency === 0 ? 1 : schFrequency);
      } else if (frequency === "Months") {
        // Monthly increment
        const day = currentDate.getDate(); // Get the day of the month
        currentDate = addMonths(currentDate, schFrequency === 0 ? 1 : schFrequency);

        // Adjust the day to ensure it stays valid for the new month
        const newMonthDays = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth() + 1,
          0
        ).getDate(); // Get the last day of the new month
        if (day > newMonthDays) {
          currentDate.setDate(newMonthDays); // Set to the last valid day of the month
        } else {
          currentDate.setDate(day); // Retain the same day if valid
        }
      }
    }

  
    return datesArray;
  };




  // const generateDates = (
  //   start,
  //   frequency,
  //   ppmScheduleId,
  //   startFromDate,
  //   schFrequency,
  //   taskdetails,
  // ) => {
  //   const currentYear = new Date().getFullYear(); // Get the current year (e.g., 2025)
  //   const startOfYear = new Date(currentYear, 0, 1); // January 1 of the current year
  //   const endOfYear = new Date(currentYear, 11, 31); // December 31 of the current year

  //   let currentDate = new Date(startFromDate); // Start from the given startFromDate
  //   const datesArray = [];
  //   const schTrackYear = String(currentYear); // Track year as a string
  //   const isFEMS = serviceType?.label === "FEMS";

  //   // Template for rows
  //   const rowsTemplate = {
  //     isdeleted: false,
  //     week: "",
  //     trackyear: "",
  //     startfromdate: "",
  //     targetdate: "",
  //     ...(isFEMS
  //       ? { femppmscheduledetails: { id: ppmScheduleId } }
  //       : { bemppmscheduledetails: { id: ppmScheduleId } }),
  //     ...(isFEMS
  //       ? { femtaskdetailsId: taskdetails }
  //       : { bemtaskdetailsId: taskdetails }),
  //   };

  //   // Align currentDate to the first target date in the current year
  //   while (currentDate < startOfYear) {
  //     currentDate =
  //       frequency === "Months"
  //         ? addMonths(currentDate, schFrequency === 0 ? 1 : schFrequency)
  //         : addWeeks(currentDate, schFrequency === 0 ? 1 : schFrequency);
  //   }

  //   // Generate dates for the current year
  //   while (currentDate <= endOfYear) {
  //     const weekNumber = getWeek(currentDate); // Calculate week number dynamically

  //     datesArray.push({
  //       ...rowsTemplate,
  //       targetdate: format(new Date(currentDate), "yyyy-MM-dd'T'HH:mm:ss"),
  //       week: weekNumber,
  //       trackyear: schTrackYear,
  //       startfromdate: startFromDate,
  //     });

  //     // Increment currentDate based on frequency
  //     currentDate =
  //       frequency === "Months"
  //         ? addMonths(currentDate, schFrequency === 0 ? 1 : schFrequency)
  //         : addWeeks(currentDate, schFrequency === 0 ? 1 : schFrequency);
  //   }

  //   console.log(datesArray, "datesArray");
  //   return datesArray;
  // };



  const processRowsAndSendPayload = async (allRows, serviceType) => {
    for (const row of allRows) {
    
      const getTaskDestails = serviceType?.label === "FEMS" ? "femtaskdetailsId" : "bemtaskdetailsId";
      const currentYear = new Date().getFullYear();

      // if(!row?.schyear === currentYear){
      const generatedDates = generateDates(
        new Date(), // or any start date
        row.period,
        row.id,
        row.startfromdate, // or any start from date
        row.scheduledfrequency,
        row?.[`${getTaskDestails}`],
        serviceType,
      );
    

      const setTracks = generatedDates.map(async (item) => {
        if (row?.schyear !== currentYear && row?.schyear !== 0) {
        // if (row?.schyear !== currentYear) {

          if (serviceType?.label === 'FEMS') {
            return await PpmPlannerRepository.addPpmscheduleTracks(item);
          } else {
            return await PpmPlannerRepository.addBemsPpmscheduleTracks(item);
          }

        }

      });

      const updatePpmScheduleTracksInsert = await Promise.all(setTracks);

    }
  };

const getService = serviceType?.label === "FEMS" ? "femworespondtypeId" : "bemworespondtypeId";

  const handleSaveClick = async () => {
    setPageLoading(true);
    await processRowsAndSendPayload(allRows, serviceType);

    try {

      if (allRows?.length > 0 && approvedBy !== '' && proposedBy !== '') {
        const approvedByError = validateField(approvedBy, 'Approved By');
        const proposedByError = validateField(proposedBy, 'Proposed By');
        if (approvedByError === '' && proposedByError === '') {
          const setTracks = allRows?.map(async (item) => {
           
            const values = {
              "id": item?.id,
              "approvedbyhss": proposedBy,
              "approvedbymoh": approvedBy,
              [`${getService}`]: item?.respondtype === 'Outsource' ? 1 : 2,
            };

            const saveApprovedBy = serviceType?.label === 'FEMS' ? await PpmPlannerRepository.updateAllApprovedBy(item?.id, values) : await PpmPlannerRepository.updateAllBemsApprovedBy(item?.id, values);
            return saveApprovedBy;

          })
       

          const updateAllApprovedTracks = await Promise.all(setTracks);
          


          const allSuccessful = updateAllApprovedTracks.every(item => item.status >= 200 && item.status <= 204);
          if (allSuccessful) {
            setConfirmationDialogOpen(true)
          } else if (updateAllApprovedTracks.status >= 400) {
           
          }
        } else {

          setErrors({
            approvedBy: approvedByError,
            proposedBy: proposedByError,
          });
        }
      } else if (approvedBy === '' && proposedBy === '') {
        const approvedByError = validateField(approvedBy, 'Approved By');
        const proposedByError = validateField(proposedBy, 'Proposed By');
        setErrors({
          approvedBy: approvedByError,
          proposedBy: proposedByError,
        });
      }
    }
    catch (e) {
      console.log(e)
    } finally {
      setPageLoading(false);
    }

  }
  const handleRefresh = () => {
    setErrors({});
    setServiceType(serviceTypeOptions?.find((item) => item?.label === 'FEMS'))
    setWorkGroup(workGroupOptions?.find((item) => item?.label === 'W1'))
    setYear(yearOptions?.find((item) => Number(item?.label) == new Date().getFullYear()) || yearOptions[(yearOptions?.length) - 1]);
    setApprovedBy('');
    setProposedBy('');
    setAllRows([]);

  }
  const handleGridRefresh = () => {
    if (allRows?.length > 0) {
      fetchPpmDetails(year?.id, serviceType, workGroup?.id);
    }

  }

  return (
    <>
      <PageLoader open={pageLoading} />
      <Box mt={{ xs: 1, sm: 2 }}>
        <DefaultCard>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Typography variant='h5'>Basic Details</Typography></Grid>
            <Grid item xs={6} md={4}>
              <CustomSelectInput
                id="service-type-label"
                label="Service Type"
                isMandatoryField={true}
                value={serviceType}
                autoFocus={true}
                options={serviceTypeOptions}
                errorMessage={errors.serviceType}
                error={!!errors.serviceType}
                onChange={(newValue) => {
                  setErrors({ ...errors, serviceType: "" });
                  setServiceType(newValue);
                }}
              />
            </Grid>

            <Grid item xs={6} md={4}>
              <CustomSelectInput
                id="work-group-label"
                label="Work Group"
                isMandatoryField={true}
                value={workGroup}
                errorMessage={errors.workGroup}
                error={!!errors.workGroup}
                options={workGroupOptions}
                onChange={(newValue) => {
                  setAllRows([]);
                  setApprovedBy('');
                  setProposedBy('');
                  setErrors({ ...errors, workGroup: "" });
                  setWorkGroup(newValue);

                }}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomSelectInput
                id="year-label"
                label="Year"
                isMandatoryField={true}
                value={year}
                errorMessage={errors.year}
                error={!!errors.year}
                options={yearOptions}
                onChange={(newValue) => {
                  handleYear(newValue);
                  setAllRows([]);
                  setApprovedBy('');
                  setProposedBy('');
                  setErrors({ ...errors, year: "" });
                  setYear(newValue);

                }}
                disabled={true}
              />
            </Grid>

            <Grid item xs={6} md={4}>
              <CustomTextField
                label="Approved By"
                id="approved-by"
                isMandatoryField={allRows?.length > 0 ? true : false}
                errorMessage={errors.approvedBy}
                error={!!errors.approvedBy}
                value={approvedBy}
                onChange={(newValue) => {
                  setErrors({ ...errors, approvedBy: "" });
                  setApprovedBy(newValue);
                }

                }
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <CustomTextField
                label="Proposed By"
                id="proposed-by"
                isMandatoryField={allRows?.length > 0 ? true : false}
                error={!!errors.proposedBy}
                errorMessage={errors.proposedBy}
                value={proposedBy}
                onChange={(newValue) => {
                  setErrors({ ...errors, proposedBy: "" });
                  setProposedBy(newValue);

                }}
              />
            </Grid>
          </Grid>

          <Box
            sx={{
              marginTop: "10px",
              display: "flex",
              gap: 2,
              justifyContent: { xs: "center", md: "end" },
            }}
          >
            <Button variant='contained' onClick={handleGetResults}>Get Results</Button>
            <Button variant='outlined' onClick={handleRefresh}>REFRESH</Button>

          </Box>    </DefaultCard></Box>

      <Box mt={{ xs: 1, sm: 2 }}>
        <DefaultCard>
          <Grid container spacing={2}>  <Grid item xs={8} md={11}><Typography variant="h6" fontWeight="bold"> {`List Of Assets : ${listLength}`}</Typography></Grid>
            <Grid item xs={4} md={1} sx={{ marginBottom: "10px", display: "flex", justifyContent: "flex-end" }}> <AddRowButton onClick={handleAddRow} /><RefreshExportButtons pagination={false} exportFunction={() => { }} exportData={allRows} title='PPM Schedule' refData={gridApi} handleRefresh={handleGridRefresh} /></Grid></Grid>

          <CustomAgGrid
            ref={gridApi}
            setGridApi={setGridApi}
            rows={allRows}
            columns={colDefs}
            isEnableView={false}
            disableFilter={false}
            handleDelete={ access?.canDelete ? (row) => {
               handleDelete(row) } : null }
            handleEdit={ access?.canEdit ? (id) => handleEdit(id, "Edit") : null }
            isLoading={loading}z
            headerLayer={3}
          />
        </DefaultCard>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            justifyContent: { xs: "center", md: "end" },
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', margin: "10px" }}>
              <Button variant='contained' onClick={handleSaveClick} sx={{ margin: "10px" }}>Save</Button>
              <Button variant='outlined' onClick={handleCancelClick} sx={{ margin: "10px" }}>BACK</Button>

            </Grid>
          </Grid>
        </Box>

      </Box>

      <AddPPM
        companyId={companyId}
        facilityId={facilityId}
        approvedBy={approvedBy}
        serviceType={serviceType}
        proposedBy={proposedBy}
        selectedValues={selectedRows}
        selectedRowsisEdit={isEdit}
        rows={allRows}
        showAddRowDialog={showAddRowDialog}
        workGroup={workGroup}
        year={year}
        onCloseAddRowDialog={(value) => { setShowAddRowDialog(value); setSelectedRows({}) }}
        PopPupLoading={addPPMLoading}
      />
      <CustomDialog
        open={confirmationDialogOpen}
        onClose={() => setConfirmationDialogOpen(false)}
        content={<>
          {commonMessages.saveSuccessmessage}
        </>}
        confirmBtn="OK"
        onConfirm={() => setConfirmationDialogOpen(false)}
      />
      <CustomDialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        onConfirm={confirmDelete}
        content={<>
          {commonMessages.deleteConfirmationMessage}</>}
        cancelBtn='No'
        confirmBtn="Yes"
      />
      <CustomDialog
        open={confirmationDeleteDialogOpen}
        onClose={() => setConfirmationDeleteDialogOpen(false)}
        content={<>
          {commonMessages.deleteSuccessMessage}
        </>}
        confirmBtn="OK"
        onConfirm={() => {
          setConfirmationDeleteDialogOpen(false);
          fetchPpmDetails(year?.id, serviceType, workGroup?.id);
        }
        }
      />
    </>
  )
};
export default PpmSchedule






